import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'

const mapStateToProps = (state, { push }: any) => ({
  step: getStep(PortfolioWizardStepNames.lease),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Lease term',
  actions: [],
})

const mapDispatchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBot)
